import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import SourceDataFindingsEdit from "@/components/lists/findings/SourceDataFindingsEdit";
import SourceDataFindingsList from "@/components/lists/findings/SourceDataFindingsList";
import CoordinatingGroupContext from "@/contexts/data/CoordinatingGroupContext";
import InstitutionContext from "@/contexts/data/InstitutionContext";
import MasterGroupContext from "@/contexts/data/MasterGroupContext";
import TrialContext from "@/contexts/data/TrialContext";
import { SourceDataFindingsInstitutionCreateLink, SourceDataFindingsParticipantCreateLink, SourceDataFindingsTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useInstitutionSourceDataFindings from "@/hooks/data/useInstitutionSourceDataFindings";
import { Typography } from "@mui/material";
import { FC, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";

const InstitutionSourceDataFindingsEdit: FC = () => {
    const { data: trial } = useContext(TrialContext);
    const { data: masterGroup } = useContext(MasterGroupContext);
    const { data: coordinatingGroup } = useContext(CoordinatingGroupContext);
    const { data: institution } = useContext(InstitutionContext);
    const { data: sourceDataFindings, loading: sourceDataFindingsLoading, validating: sourceDataFindingsValidating } = useInstitutionSourceDataFindings(institution?.id, { revalidateOnFocus: false });

    const { sourceDataFindingId } = useParams();

    const sourceDataFinding = useMemo(() => {
        return sourceDataFindings?.find(x => x.id === sourceDataFindingId as any)
    }, [sourceDataFindings, sourceDataFindingId])

    const loading = sourceDataFindingsLoading;
    const validating = sourceDataFindingsValidating;

    return (
        <>
            <SetLinks 
                createTrialLink={SourceDataFindingsTrialCreateLink} 
                createInstitutionLink={SourceDataFindingsInstitutionCreateLink} 
                createParticipantLink={SourceDataFindingsParticipantCreateLink}  
            />
            <IsLoading name="institution-findings-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Findings
                </Typography>
                <SourceDataFindingsEdit
                    sourceDataFinding={sourceDataFinding}
                />
            </Show>
        </>
    )
};

export default InstitutionSourceDataFindingsEdit;